import React from 'react';
import {Routes, Route, Outlet} from 'react-router-dom';
import {ProjectsProvider} from './ProjectsContext';
import SiteGate from './views/adminpage/SiteGate';
import Universe from './views/universe/Universe';
import AdminList from './views/adminpage/AdminList';
import ProjectForm from './views/adminpage/Form/ProjectForm';
import UniverseEditor from './views/adminpage/UniverseEditor';
import Impressum from './views/kontekt/Impressum';
import Datenschutz from './views/kontekt/Datenschutz';
import AdminGate from './views/adminpage/AdminGate';

function ProtectedLayout() {
    return (
        <SiteGate>
            <ProjectsProvider>
                <Outlet/>
            </ProjectsProvider>
        </SiteGate>
    );
}

export default function App() {
    return (
        <Routes>
            <Route element={<ProtectedLayout/>}>
                <Route path="/" element={<Universe/>}/>
                <Route element={<AdminGate/>}>
                    <Route path="/intern" element={<AdminList/>}/>
                    <Route path="/intern/universum" element={<UniverseEditor/>}/>
                    <Route path="/intern/projekt/neu" element={<ProjectForm/>}/>
                    <Route path="/intern/projekt/:id" element={<ProjectForm/>}/>
                </Route>
            </Route>
            <Route path="/impressum" element={<Impressum/>}/>
            <Route path="/datenschutz" element={<Datenschutz/>}/>
        </Routes>
    );
}